import { Position3D } from '../Position';
import { Range } from '../util';
import { Vector3D } from '../Vector';
export class AxisAlignedBoundingBox {
    static fromTuple(min, max) {
        return new AxisAlignedBoundingBox(Position3D.fromTuple(min), Position3D.fromTuple(max));
    }
    _min;
    _max;
    constructor(min, max) {
        this._min = min.minimum(max);
        this._max = max.maximum(min);
    }
    /**
     * a tuple of the minimum position and the maximum position
     *  e.g.
     *
     * `[min, max]`
     */
    value() {
        return [this._min, this._max];
    }
    min() {
        return this._min;
    }
    max() {
        return this._max;
    }
    centre() {
        return Position3D.fromTuple([
            (this._min.x() + this._max.x()) / 2,
            (this._min.y() + this._max.y()) / 2,
            (this._min.z() + this._max.z()) / 2,
        ]);
    }
    union(right) {
        return new AxisAlignedBoundingBox(this._min.minimum(right.min()), this._max.maximum(right.max()));
    }
    dimensions() {
        return this.max().subtract(this.min());
    }
    corners() {
        const corners = new Range(0, 7);
        // TODO: figure out a way to avoid this ridiculous juggling to please the compiler
        const [a, b, c, d, e, f, g, h] = corners.map(i => new Position3D(i & 0b1 ? this._max.x() : this._min.x(), i & 0b10 ? this._max.y() : this._min.y(), i & 0b100 ? this._max.z() : this._min.z()));
        return [a, b, c, d, e, f, g, h];
    }
}
/**
 * An implementation of IAxisAlignedBoundingBox which reports the
 * minimum as Infinity and the maximum as -Infinity.
 * This is useful when combining multiple AABBs (with union) as
 * it allows for a starting point which does not implicitly encode
 * a position. Subsequent unions will always take the new AABB as
 * the "real" starting point (e.g. in a reducer)
 */
export class EmptyAxisAlignedBoundingBox {
    _min = new Position3D(Infinity, Infinity, Infinity);
    _max = new Position3D(-Infinity, -Infinity, -Infinity);
    corners() {
        return [
            this._min,
            this._min,
            this._min,
            this._min,
            this._max,
            this._max,
            this._max,
            this._max,
        ];
    }
    max() {
        return this._max;
    }
    min() {
        return this._min;
    }
    centre() {
        return new Position3D(NaN, NaN, NaN);
    }
    dimensions() {
        return new Vector3D([NaN, NaN, NaN]);
    }
    union(right) {
        return right;
    }
    value() {
        return [this._min, this._max];
    }
}
//# sourceMappingURL=AxisAlignedBoundingBox.js.map